import React from 'react';

function Select(props) {
  return (
    <select
      {...props}
      className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
    >
      {props.children}
    </select>
  );
}

export default Select;
